export default {
	data() {
    return {
      scrolled: 0,
      showFixed:false,
		};
  },
	methods: {
		handleScroll() {
			this.scrolled = window.scrollY;
      this.showFixed = this.scrolled > 270 && window.screen.width > 995;
		},
	},
		beforeMount () {
			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed () {
			window.removeEventListener('scroll', this.handleScroll);
		}
}
